import { useMemo } from "react";
import useUserState from "ui/adapter/state/useUserState";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import { APP_TABS } from "../AppTabs.constants";
import { AppTab } from "../AppTabs.types";

export default function useAppTabs(): AppTab[] {
    const { selectedRole } = useUserState();
    const tabs = useMemo(() => {
        if (!selectedRole) return [];
        return APP_TABS.filter((tab) => {
            if (tab.path === MainRoutes.POINTS_OF_SELL) {
                return Boolean(selectedRole.partner?.pointsOfSell?.length && tab.roles.includes(selectedRole.roleType));
            } else {
                return tab.roles.includes(selectedRole.roleType);
            }
        });
    }, [selectedRole]);

    return tabs;
}
